import type { ConfigType } from '@plone/registry';
import SummaryListingBlockTemplate from '@kitconcept/volto-light-theme/components/Blocks/Listing/SummaryTemplate';
import { defaultStylingSchema } from '@kitconcept/volto-light-theme/components/Blocks/schema';
import { composeSchema } from '@plone/volto/helpers/Extensions';
import { gridSchemaEnhancer } from '../components/Blocks/Grid/schema';
import { imageDownloadSchemaEnhancer } from '../components/Blocks/Image/schema';

export default function install(config: ConfigType) {
  // Language settings
  config.settings.isMultilingual = false;
  config.settings.supportedLanguages = ['de'];
  config.settings.defaultLanguage = 'de';

  const COLORS = [
    {
      style: {
        '--theme-color': '#fff', // Block Wrapper
        '--theme-high-contrast-color': '#ecebeb', // Cards in Grid block
        '--theme-foreground-color': '#323232',
        '--theme-low-contrast-foreground-color': '#555555',
      },
      name: 'default',
      label: 'Default',
    },
    {
      style: {
        '--theme-color': '#ecebeb',
        '--theme-high-contrast-color': '#fff',
        '--theme-foreground-color': '#323232',
        '--theme-low-contrast-foreground-color': '#555555',
      },
      name: 'grey',
      label: 'Grey',
    },
    {
      style: {
        '--theme-color': '#dce6ff',
        '--theme-high-contrast-color': '#fff',
        '--theme-foreground-color': '#323232',
        '--theme-low-contrast-foreground-color': '#ababab',
      },
      name: 'blue',
      label: 'Blue',
    },
    {
      style: {
        '--theme-color': '#b4dcf5',
        '--theme-high-contrast-color': '#fff',
        '--theme-foreground-color': '#323232',
        '--theme-low-contrast-foreground-color': '#ababab',
      },
      name: 'cyan2',
      label: 'Cyan',
    },
    {
      style: {
        '--theme-color': '#6e6e6e',
        '--theme-high-contrast-color': '#071604',
        '--theme-foreground-color': '#fff',
        '--theme-low-contrast-foreground-color': '#ababab',
      },
      name: 'green',
      label: 'Dunkelgrau',
    },
  ];

  // Custom Colors for all Blocks
  config.blocks.themes = COLORS;

  config.blocks.blocksConfig.listing.variations = [
    ...config.blocks.blocksConfig.listing.variations,
    {
      id: 'portrait',
      title: 'Portrait',
      template: SummaryListingBlockTemplate,
    },
  ];

  config.blocks.blocksConfig.gridBlock.schemaEnhancer = composeSchema(
    defaultStylingSchema,
    gridSchemaEnhancer,
  );

  config.blocks.blocksConfig.gridBlock.themes = COLORS;

  config.blocks.blocksConfig.image.schemaEnhancer = composeSchema(
    config.blocks.blocksConfig.image.schemaEnhancer,
    imageDownloadSchemaEnhancer,
  );

  return config;
}
